import { render, staticRenderFns } from "./InputEnglish.vue?vue&type=template&id=4e5806f6&scoped=true&lang=pug&"
import script from "./InputEnglish.vue?vue&type=script&lang=ts&"
export * from "./InputEnglish.vue?vue&type=script&lang=ts&"
import style0 from "./InputEnglish.vue?vue&type=style&index=0&id=4e5806f6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5806f6",
  null
  
)

export default component.exports